import { Link } from "@magnetic/link";

import DataViewer from "src/components/dataViewer";
import { BaseDataType } from "src/dataTypes/dataType";

type DataView = {
  width?: number;
  key?: number;
  readonly data: unknown | undefined;
  readonly expandDepth?: number;
  readonly hideRoot?: boolean;
};

export class DataViewerType extends BaseDataType<DataView> {
  DataViewerType = true;
  tag = "DataViewerType";
  valueOf(): DataView {
    return (
      this.value ?? {
        key: 0,
        data: undefined,
        expandDepth: 0,
        hideRoot: false
      }
    );
  }
  compare(b: DataViewerType): number {
    return (
      (this.valueOf()?.expandDepth || 0) - (b?.valueOf()?.expandDepth || 0)
    );
  }
  render() {
    const val = this.valueOf();
    if (val.width) {
      return (
        <div style={{ width: val.width }}>
          <DataViewer
            key={val?.key}
            data={val?.data}
            expandDepth={val?.expandDepth}
            hideRoot={val?.hideRoot}
          />
        </div>
      );
    }
    return (
      <DataViewer
        key={val?.key}
        data={val?.data}
        expandDepth={val?.expandDepth}
        hideRoot={val?.hideRoot}
      />
    );
  }
}

export class SyncCatType extends BaseDataType<string> {
  SyncCatType = true;
  tag = "SyncCatType";
  valueOf(): string {
    return this.value ?? "";
  }
  compare(b: SyncCatType): number {
    return this.valueOf().localeCompare(b?.valueOf());
  }
  render() {
    const link = this.valueOf();
    return (
      <Link className="cnc-small-font" href={link}>
        Run
      </Link>
    );
  }
}
